import { Inputs } from '../../../../types/Enums';
import {
  InputComponentsConfigType,
  InputConfig,
} from '../../../../types/ConfigTypes';
import { insurancePoliciesQuestionId } from '../constants/hardcodedFlowIds';

export const hardcodedCompanyScanConfig = {
  fullyHardcodedIds: {
    [insurancePoliciesQuestionId]: true,
  },
  fullwidthIds: {
    'company_management.directors_future_plans': true,
    'assets.machines': true,
    'company_activity.main_activity': true,
    [insurancePoliciesQuestionId]: true,
  },
};

/**
 * CONFIGS
 */
const defaultConfig: InputConfig = {
  styling: {
    justifySelf: 'center',
    w: '100%',
  },
  config: {
    isTitleHidden: false,
  },
  gridConfig: {
    isFullScreen: false,
  },
};

const titleHiddenConfig: InputConfig = {
  ...defaultConfig,
  config: {
    isTitleHidden: true,
  },
};

const fullWidthConfig: InputConfig = {
  ...defaultConfig,
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isFullWidth: true,
  },
};

const fullWidthWithTitle: InputConfig = {
  ...defaultConfig,
  gridConfig: {
    isFullWidth: true,
  },
};

const fullWidthWithMargin: InputConfig = {
  ...defaultConfig,
  styling: {
    my: 4,
    justifySelf: 'center',
    w: '100%',
  },
  gridConfig: {
    isFullWidth: true,
  },
};

/**
 * -----------------------------
 */

// This will give every InputType the defaultConfig
const allInputsDefaultConfig = Object.keys(Inputs).reduce(
  (obj, key) => ({ ...obj, [key]: defaultConfig }),
  {},
) as InputComponentsConfigType;

// Here you can specify a custom config for certain Input types
const InputComponentsConfig: InputComponentsConfigType = {
  ...allInputsDefaultConfig,
  [Inputs.MULTISELECT]: fullWidthWithTitle,
  [Inputs.CHECKBOX]: titleHiddenConfig,
  [Inputs.ADDRESS]: fullWidthConfig,
  [Inputs.RADIO]: fullWidthConfig,
  [Inputs.MULTILINE]: fullWidthWithTitle,
  [Inputs.RICH_TEXT]: fullWidthWithTitle,
  [Inputs.AMOUNT]: fullWidthConfig,
  [Inputs.LINK]: fullWidthWithTitle,
  [Inputs.LINKS]: fullWidthWithTitle,
  [Inputs.ACCIDENT]: fullWidthWithTitle,
  [Inputs.COMPANY_LOAN]: fullWidthWithTitle,
  [Inputs.COMPANY_LEASE]: fullWidthWithTitle,
  [Inputs.COMPANY_INVESTMENT]: fullWidthWithTitle,
  [Inputs.UNITS]: fullWidthWithMargin,
  [Inputs.CLAIMS]: fullWidthWithTitle,
  [Inputs.NACE_CODE]: fullWidthWithTitle,
  [Inputs.TABLE]: fullWidthConfig,
  [Inputs.NOTES]: fullWidthWithTitle,
  [Inputs.INDEX_SELECT]: fullWidthWithTitle,
  [Inputs.INDEX_MULTISELECT]: fullWidthWithTitle,
  [Inputs.INDEX_PERCENTAGE]: fullWidthWithTitle,
  [Inputs.NUMBER_PLATE]: fullWidthConfig,
  [Inputs.COVERAGE]: fullWidthWithTitle,
  [Inputs.DISPLAY]: fullWidthConfig,
};

export default InputComponentsConfig;
